var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHwBackingAtStartIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.35 16L16 25.8813V6.11875L2.35 16ZM16.125 4C17.1625 4 18 4.84375 18 5.875V12.3375L29.0187 4.35625C29.3438 4.125 29.725 4 30.125 4C31.1625 4 32 4.84375 32 5.875V26.125C32 27.1625 31.1625 28 30.125 28C29.7313 28 29.3438 27.875 29.025 27.6437L18 19.6625V26.125C18 27.1625 17.1562 28 16.125 28C15.7312 28 15.3438 27.875 15.025 27.6437L0.61875 17.2125C0.23125 16.9312 0 16.4812 0 16C0 15.5188 0.23125 15.0688 0.61875 14.7875L15.0188 4.35625C15.3438 4.125 15.725 4 16.125 4ZM18 17.1938L30 25.8813V6.11875L18 14.8062V17.1938Z",
    fill: "#18303E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHwBackingAtStartIcon);
export default __webpack_public_path__ + "static/media/hw_backing_at_start_icon.a8e86fb275085b64fb5154d9aecfb003.svg";
export { ForwardRef as ReactComponent };